import styled from 'styled-components';

const Title = styled.span`
  font-weight: 700;
`;

Title.displayName = 'Title';

export default Title;
